import { defineMessages } from 'react-intl';

export default defineMessages({
  totalTitle: {
    id: 'sku.item-save-errors.total-title',
    defaultMessage: "We couldn't save your item",
  },
  totalBody: {
    id: 'sku.item-save-errors.total-body',
    defaultMessage: 'Nothing was changed. Check your connection and try again.',
  },
  totalBodyUncertain: {
    id: 'sku.item-save-errors.total-body-uncertain',
    defaultMessage: 'Check your connection and try again.',
  },
  categoriesTitle: {
    id: 'sku.item-save-errors.categories-title',
    defaultMessage: "Your item was saved, but it wasn't added to a category",
  },
  categoriesBody: {
    id: 'sku.item-save-errors.categories-body',
    defaultMessage: 'Add a category below and save again.',
  },
  modifiersTitle: {
    id: 'sku.item-save-errors.modifiers-title',
    defaultMessage: "Your item was saved, but your modifiers weren't attached",
  },
  modifiersBody: {
    id: 'sku.item-save-errors.modifiers-body',
    defaultMessage: 'Add them below and save again.',
  },
  bothTitle: {
    id: 'sku.item-save-errors.both-title',
    defaultMessage: "Your item was saved, but its category and modifiers weren't",
  },
  bothBody: {
    id: 'sku.item-save-errors.both-body',
    defaultMessage: 'Add them below and save again.',
  },
  categoriesInline: {
    id: 'sku.item-save-errors.categories-inline',
    defaultMessage: 'Not saved. Add a category and save again.',
  },
  modifiersInline: {
    id: 'sku.item-save-errors.modifiers-inline',
    defaultMessage: 'Not attached. Add your modifiers and save again.',
  },
});
